import React, { useState, useEffect, useRef } from "react";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { styled } from "@mui/material/styles";
import { Outlet, useLocation } from "react-router-dom";
import { useMedia } from "react-use";
import Header from "../Header/index";
import ScrollToTopButton from "../ScrollToTopButton";
import { showBanner } from "../../../MasterData/index";

const ClippedDrawer = React.memo((props) => {
  const showMobileDrawer = useMedia("(max-width: 600px)");
  const [outletLoaded, setOutletLoaded] = useState(false);
  const location = useLocation();

  const paddingTopValue = showBanner ? "80px" : "64px"; // Adjust padding to account for the fixed header

  useEffect(() => {
    const timeout = setTimeout(() => {
      setOutletLoaded(true);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const Main = styled("main")(({ theme }) => ({
    flexGrow: 1,
    marginTop: "64px", // Reserve space for the fixed header
    overflowY: "auto", // Enable scrolling only for the body content
    height: "calc(100vh - 64px)", // Ensure the body content fills the remaining height
    padding: theme.spacing(3),
  }));

  const AppBar = styled(MuiAppBar)(({ theme }) => ({
    backgroundColor: "#fff",
    position: "fixed", // Keep the header fixed at the top
    top: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.drawer + 1, // Ensure it stays above other elements
    boxShadow: "0px 4px 38px 0px rgba(0, 0, 0, 0.08)",  }));  // Check if user is authenticated
  // Revert to always showing the header since we fixed the MenuList component
  // const isAuthenticated = localStorage.getItem("isAuthenticated");

  return (
    <>
      {/* Fixed Header */}
      <AppBar>
        <Header
          handleDrawerToggle={props.handleDrawerToggle}
          hideSideBar={props.hideSideBar}
          showMobileDrawer={showMobileDrawer}
          isDarkTheme={props.isDarkTheme}
        />
      </AppBar>

      {/* Scrollable Body Content */}
      <Box>
        <CssBaseline />
        <Main>
          {location.pathname === "/" && (
            <div className="content_divider_ecllips"></div>
          )}
          {outletLoaded && <Outlet />}
          <ScrollToTopButton />
        </Main>
      </Box>
    </>
  );
});

export default ClippedDrawer;
